module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAFVBMVEUAAAD/rDP/rDP/rDP/rDP/rDP/rDNLc9G3AAAABnRSTlMAgM8QAJ+N+GT2AAAA8klEQVR4Xp3WwUnFUBCG0a+Ghw08FAsQG9CMLaQAF+m/BPc5BMOd9XACl8z801o9np9zquZUP8fx+m/Tfhy/ZyohqYSkEpJKSCohqYSkEpJKSCohqYSkEpJKSCohqYSkEpJKSCohqYSkEpJKSCohqYSkEpJKSCohqYSkEpJKSCohqTYgqOkLgHrpG4B6u9V073PzDsAbNB83nmA2KR8TCmgaKKBpoICmgQKaBuri95VyEKQcKSmHE+pizKVcGFKuHimXmNT1Otx2ocUV7bJfjA0DaDHKDMXleDWo1yPf42H9DPGgWT+NPLLWz7Xt8RybKOsPCmpBtMQaQ0kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f536.png
// module id = 1129
// module chunks = 0